import createIcon from "./createIcon";

export const VipPointerIcon = createIcon('VipPointer', (props) => {
  return (
    <svg width="34" height="20" {...props} viewBox="0 0 34 20" fill="none">
      <defs>
        <linearGradient id="paint_linear_5" x1="39.2409439" x2="-6.82316971" y1="3.5" y2="3.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(125,98,71)" offset="0" stopOpacity="1" />
          <stop stopColor="rgb(122,95,68)" offset="1" stopOpacity="1" />
        </linearGradient>
      </defs>
      <path d="M39.1715 -13L-5.17153 -13C-6.9529 -13 -7.84555 -10.6108 -6.58569 -9.21351L-5.99971 -8.56385L-10 -8.56385L14.8788 19.0255C16.0507 20.3248 17.9503 20.3248 19.1212 19.0255L44 -8.56385L39.9997 -8.56385L40.5857 -9.21351C41.8455 -10.6108 40.9539 -13 39.1715 -13Z" fill="url(#paint_linear_5)" fillRule="evenodd" />
      <path d="M3.41421 3.41421L36.5858 36.5858C37.8457 37.8457 36.9534 40 35.1716 40L1 40C0.447715 40 0 39.5523 0 39L0 4.82843C0 3.04662 2.15428 2.15428 3.41421 3.41421Z" fill="rgb(255,255,255)" fillRule="evenodd" transform="matrix(0.669988,-0.742372,0.669988,0.742372,-10,-15)" />
    </svg>
  )
});